import type { Category } from 'packages/openclassrooms/openclassrooms-sdk-web/src';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useCategories, useGet: useCategory } = getCRUDHooks<Category>({
  entityName: 'category',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.categories,
});

export { useCategories, useCategory };
